import Spinners from "components/Shared/Spinners"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap"
import { getAssessmentList } from "store/actions/interviewsAction"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import StartAssessment from "./StartAssessment "

const Interviews = () => {
  const { loading, assessmentsList } = useSelector(state => state.Interviews)

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [modal, setModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})

  // Toggle function to open/close modal
  const toggle = () => setModal(!modal)

  useEffect(() => {
    getAllData()
  }, [])

  const getAllData = () => {
    const payload = {
      limit: 100,
      page_number: 1,
      order_by: 1,
      filters: {
        interview_schedule_id: 0,
        status: -1,
        search: "",
        date_range: {
          start_date: "",
          end_date: "",
        },
      },
    }
    dispatch(getAssessmentList(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <Col xl="12">
                <h4 className="card-title mb-4">Interviews</h4>
                <Card className="user_personal_info">
                  <CardBody>
                    <Table className="table mb-0" hover>
                      <thead className="table-light full_th">
                        <tr>
                          <th>{t("S. No.")}</th>
                          {/* <th>{t("Total Capacity")}</th>
                          <th>{t("Total User Enrolled")}</th>
                          <th>{t("Total Available Seat")}</th> */}
                          <th>{t("Name")}</th>
                          <th>{t("National Id")}</th>
                          <th>{t("Phone")}</th>
                          <th>{t("Nationality")}</th>
                          <th>{t("Schedule Date")}</th>
                          <th>{t("Schedule Time")}</th>
                          <th>{t("Action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {assessmentsList?.map((item, index) => (
                          <tr key={index} className="cursor-pointer">
                            <td>{index + 1}</td>
                            {/* <td>{item?.interview_schedule?.total_capacity}</td>
                            <td>
                              {item?.interview_schedule?.total_user_enrolled}
                            </td>
                            <td>
                              {item?.interview_schedule?.total_available_seat}
                            </td> */}
                            <td>{item?.user?.name}</td>
                            <td>{item?.user?.national_id}</td>
                            <td>{item?.user?.phone}</td>
                            <td>
                              {item?.interview_schedule?.nationality?.name}
                            </td>
                            <td>{item?.interview_schedule?.start_date}</td>
                            <td>
                              {item?.interview_schedule?.start_time} ~{" "}
                              {item?.interview_schedule?.end_time}
                            </td>
                            <td>
                              {!item?.is_submitted && (
                                <Button
                                  color="success"
                                  onClick={() => {
                                    toggle()
                                    setSelectedItem(item)
                                  }}
                                >
                                  Start Interview
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        )}
      </div>
      <Modal isOpen={modal} toggle={toggle} className="full_screen_modal">
        <ModalHeader toggle={toggle}>Start Interview</ModalHeader>
        <StartAssessment
          selectedItem={selectedItem}
          toggle={toggle}
          getAllData={getAllData}
        />
      </Modal>
    </React.Fragment>
  )
}

export default Interviews
